module.exports = __webpack_public_path__ + "static/All-Apps-Transparent-a302e9a5412dffaefb3072f0575a1b77.png";